import { Routes } from '@angular/router';
import { authenticationGuard } from './Core/Guards/authentication.guard';

export const routes: Routes = [
  {
    path: '',
    canActivate: [authenticationGuard],
    loadComponent: () =>
      import('./layout/Agent-View/agent-view.component').then(
        (m) => m.AgentViewComponent,
      ),
    loadChildren: () =>
      import('./layout/Agent-View/agent-view-routing.module').then(
        (m) => m.AgentViewRoutingModule,
      ),
  },
  {
    path: '**',
    redirectTo: 'dashboard',
  },
];
